import { gql } from '@apollo/client';
import { PartnerUserInfoShared } from '../fragments';

export default gql`
  mutation restorePartnerUser($input: PartnerUserRestoreInput!) {
    restorePartnerUser(input: $input) {
      clientMutationId
      partnerUser {
        ...PartnerUserInfoShared
      }
    }
  }
  ${PartnerUserInfoShared}
`;
